import { Link } from 'react-router';

import {
  Anchor,
  Heading,
  Section,
  SubHeading,
  UnorderedList
} from '~/components/Prefabs';

export default function English() {
  return (
    <>
      <h1 className="text-title-lg">Terms & Conditions</h1>
      <Section>
        <Heading>1. Introduction</Heading>
        <p>
          1.1 These terms of service apply to your use of our website,{' '}
          <Link className="font-semibold underline" to="/">
            https://thesolesupplier.co.uk/
          </Link>{' '}
          (the "Website") and our mobile application (the "App"), both as
          amended from time to time (together referred to as the "The Sole
          Supplier Marketplace") whether as a website visitor, seller or a buyer
        </p>
        <p>
          1.2 BY USING OUR WEBSITE OR BY DOWNLOADING OUR APP, YOU CONFIRM THAT
          YOU ACCEPT THESE TERMS OF SERVICE IN FULL AND THAT YOU AGREE TO COMPLY
          WITH THEM. IF YOU DO NOT AGREE TO THESE TERMS, PLEASE DO NOT USE OUR
          WEBSITE OR DOWNLOAD OUR APP. WE WILL ALSO ASK YOU TO ACCEPT THESE
          TERMS WHEN REGISTERING FOR AN ACCOUNT AND/OR MAKING A PURCHASE THROUGH
          THE SOLE SUPPLIER MARKETPLACE.
        </p>
        <p>
          1.3 Every time you wish to use The Sole Supplier Marketplace, please
          check these terms regularly to ensure that you understand the terms
          that apply at that time.
        </p>
        <p>
          1.4 Amongst other things, these terms of service set out the terms and
          conditions under which you browse or buy products on The Sole Supplier
          Marketplace and form the basis of the agreement between you and the
          seller of any product you buy on The Sole Supplier Marketplace. In
          addition to these terms:
        </p>
        <UnorderedList>
          <li>
            where you sell a product through The Sole Supplier Marketplace, the
            seller terms apply; and
          </li>
          <li>
            our privacy policy and cookie policy will also apply to all uses of
            The Sole Supplier Marketplace.
          </li>
        </UnorderedList>
        <p>
          1.5 These terms of service do not apply to your purchase of a product
          from a third-party website linked to via The Sole Supplier
          Marketplace.
        </p>
        <p>
          1.6 We reserve the right, from time to time, without prior notice, to:
        </p>
        <UnorderedList>
          <li>
            update and change The Sole Supplier Marketplace, including any
            content we link to on The Sole Supplier Marketplace as we see fit;
          </li>
          <li>
            stop providing The Sole Supplier Marketplace, or features of The
            Sole Supplier Marketplace, to you or to members generally or create
            usage limits for The Sole Supplier Marketplace;
          </li>
          <li>
            permanently or temporarily terminate or suspend your access to The
            Sole Supplier Marketplace, without liability, if in our sole
            determination you violate any provision of these terms of service.
          </li>
        </UnorderedList>
      </Section>
      <Section>
        <Heading>2. About Sole Supplier</Heading>
        <p>
          2.1 The Sole Supplier Marketplace is owned and operated by The Sole
          Supplier Limited ("Sole" "Us" "We"). We are registered in England and
          Wales under company number 09098756 and have our registered office
          address at: Ckr House 70 East Hill, Dartford, Kent, DA1 1RZ. Our VAT
          number is 220675526.
        </p>
        <p>
          2.2 We grant you the right to use our App and/or our Website, as
          permitted in these terms of service, which we may amend from time to
          time.
        </p>
        <p>
          2.3 To contact us, please email{' '}
          <Anchor href="mailto:support@thesolesupplier.zendesk.com">
            support@thesolesupplier.zendesk.com
          </Anchor>
        </p>
      </Section>
      <Section>
        <Heading>3. Our Services</Heading>
        <SubHeading>Sole as The Sole Supplier Marketplace</SubHeading>
        <p>
          3.1 We enable users of The Sole Supplier Marketplace to buy and sell
          products. We do not sell any products directly ourselves. Note that if
          you buy a product on or through The Sole Supplier Marketplace, the
          contract for sale is between the seller and the buyer, and Sole is not
          a party to that contract. We do not, at any time, have possession of
          the product(s).
        </p>
        <p>
          3.2 In order to purchase a product, you must first register as a
          member of The Sole Supplier Marketplace.
        </p>
        <p>
          3.3 You can register by providing all information required or by
          signing in with your Facebook (or other social network) account
          details.
        </p>
        <p>
          3.4 You will also be required to provide a payment method before you
          will be permitted to purchase any product. We do not store any
          information in relation to your payment method. This is processed and
          stored by the designated payment provider.
        </p>
        <p>
          3.5 If you are considering buying a particular product, please read
          the description of the product carefully before placing your order. If
          you have any questions regarding the product you should raise this
          directly with us before you place your order. We will answer your
          query on behalf of the seller.
        </p>
        <p>
          3.6 You acknowledge that once you place an order, you are making an
          irrevocable offer to purchase that product and are committing to pay
          the seller the amount shown in the purchase flow. See paragraph 4
          below for payment and delivery information.
        </p>
        <p>
          3.7 If the seller is unable to accept your order, we will inform you
          of this via email and will not charge you for the product. This might
          be because the product is no longer available, we have identified an
          error in the price or description of the product or because the seller
          is unable to meet a delivery deadline you have specified.
        </p>
        <p>
          3.8 Otherwise, once you receive the email order confirmation from us,
          a binding contract of sale is formed between you and the seller.
        </p>
        <SubHeading>Sole as an Affiliate Marketer</SubHeading>
        <p>
          3.9 In addition to enabling you to purchase products from sellers on
          The Sole Supplier Marketplace, we may also provide you with links to
          other third party websites where you will be able to purchase products
          that you are interested in, for which we receive affiliate marketing
          fees from the affiliate third party website(s) ("Third Party").
        </p>
        <p>
          3.10 By your use of our Website and/or App, you agree that that we
          will track you from the Website and/or App through to the Third Party
          where you make a purchase (whether that is of the product you clicked
          on the Website and/or App or another product entirely) and you accept
          that we may be paid an affiliate payment in accordance with the terms
          below and our Privacy and Cookie Policy.
        </p>
        <p>
          3.11 The affiliate payments we receive from Third Parties tend to take
          one of the following forms of payment:
        </p>
        <UnorderedList>
          <li>
            a payment each time you click through to a Third Party and purchase
            a product from their website; or
          </li>
          <li>
            payment for advertising on our Website and/or App, or other
            additional exposure that we may provide (such as within the emails
            to our customers), albeit if you do click one of our advertisements
            and make a purchase we may receive an affiliate payment from that
            sale, or other sales that you make on that website.
          </li>
        </UnorderedList>
        <p>
          3.12 In each case the payment we receive may, or may not, be linked to
          the product that you originally clicked on our Website and/or App. For
          example, we may still receive an affiliate payment if you purchase a
          different product from the same site.
        </p>
        <p>
          3.13 Any and all data you provide to us (personal or otherwise) will
          be dealt with in accordance with our privacy policy and all data you
          provide to any Third Party (personal or otherwise) by means of their
          website will be dealt with in accordance with any privacy policy that
          may apply to the use of such website.
        </p>
        <p>
          3.14 The links we provide to Third Parties should not be interpreted
          as approval by us of the linked websites or any of the information you
          may obtain from them. We have no control over the contents of those
          sites or resources. Purchases that you make from those Third Parties
          are from those sites and will be on their terms, not ours. For the
          avoidance of doubt, any returns that you would like to make should be
          to the retailer from whom you purchased the goods.
        </p>
        <p>
          3.15 Product details may vary from retailer to retailer and country to
          country. The specifications shown on our Website and/or App are
          indicative only, and you should check the product details and
          specifications on the website that you make any purchase from, as well
          as ensuring that you carefully consider their purchase terms.
        </p>
      </Section>
      <Section>
        <Heading>4. Payment and Delivery</Heading>
        <p>
          4.1 Where you have ordered a product on The Sole Supplier Marketplace,
          the terms of this paragraph 4 shall apply.
        </p>
        <p>4.2 All prices include any applicable VAT.</p>
        <p>
          4.3 The price of a product as stated on The Sole Supplier Marketplace
          does not include delivery charges and/or other charges (such as
          customs charges or processing fees, if applicable). Any delivery
          charges or other charges will be made clear before the check-out
          process.
        </p>
        <p>
          4.4 Payments for all products must be paid in Pound Sterling or such
          other currency as stated on our website from time to time. Payment
          will be taken when we send you an email order confirmation.
        </p>
        <p>
          4.5 The Sole Supplier Marketplace sets out the method of payments that
          we are able to accept and the delivery options available to you.
        </p>
      </Section>
      <Section>
        <Heading>
          6. Availability and The Sole Supplier Marketplace content
        </Heading>
        <p>
          6.1 We do not guarantee that The Sole Supplier Marketplace, or any
          content on our The Sole Supplier Marketplace, will always be available
          or be uninterrupted. We may suspend, withdraw or restrict the
          availability of all, or any part of, or item upon, our The Sole
          Supplier Marketplace for business or operational reasons. The Sole
          Supplier Marketplace may be unavailable from time to time due to
          mechanical, telecommunication, software, hardware and third-party
          failures. We cannot predict or control when such downtime may occur
          nor control the duration of such downtime.
        </p>
        <p>
          6.2 You are also responsible for ensuring that all persons who access
          our The Sole Supplier Marketplace through your internet connection are
          aware of these terms of service and that they comply with them.
        </p>
        <p>
          6.3 The content on The Sole Supplier Marketplace is provided for
          general information only. It is not intended to amount to advice on
          which you should rely. Any claims that are made in respect of any
          products on The Sole Supplier Marketplace (including shoes) are claims
          which we have understood are made by the manufacturer or seller.
          Should you have any question about any of them you should contact
          either:
        </p>
        <UnorderedList>
          <li>
            the shop selling them, or the manufacturer, in respect of products
            sold via Third Parties; or
          </li>
          <li>
            us and we will liaise with the seller, in respect of products sold
            on The Sole Supplier Marketplace.
          </li>
        </UnorderedList>
        <p>
          6.4 Although we make reasonable efforts to update the information on
          our The Sole Supplier Marketplace, we make no representations,
          warranties or guarantees, whether express or implied, that the content
          on our The Sole Supplier Marketplace is accurate, complete or up to
          date, or that any product may be available from any seller or Third
          Party. In particular, we are not responsible for misprints,
          out-of-date information, technical or pricing inaccuracies,
          typographical or other errors appearing on The Sole Supplier
          Marketplace.
        </p>
        <p>
          6.5 Please note that The Sole Supplier Marketplace may contain images
          of trainers that may vary slightly from the photos provided of them
          (in particular, in respect of the colour, which may differ slightly
          depending on the lighting). As we are not the seller of any products
          shown or linked to via The Sole Supplier Marketplace, we have no
          control and do not give any commitment relating to the existence,
          quality, safety, truth or accuracy of any picture or description of
          the products, and we have no liability in this respect.
        </p>
      </Section>
      <Section>
        <Heading>7. The App System Requirements and Updates</Heading>
        <p>
          7.1 Where you are using the App, the ways in which you can use the App
          and related documentation may also be controlled by the relevant
          appstore's rules and policies (which may be Google or Apple)
          ("Appstore Rules"). In the event of any conflict or inconsistency
          between these terms of service and the Appstore Rules, the Appstore
          Rules shall prevail.
        </p>
        <p>
          7.2 The App requires a compatible Apple iPhone, where the minimum OS
          is iOS 13.0.
        </p>
        <p>
          7.3 We are giving you personally the right to use the App as set out
          above. You may not otherwise transfer the App to someone else, whether
          for money, for anything else or for free. If you sell any device on
          which the App is installed, you must remove the App from it.
        </p>
        <p>
          7.4 From time to time we may automatically update the App and change
          the service available on the App to improve performance, enhance
          functionality, reflect changes to the operating system or address
          security issues. Alternatively we may ask you to update the App for
          these reasons.
        </p>
        <p>
          7.5 If you choose not to install such updates or if you opt out of
          automatic updates you may not be able to continue using the App and
          the services available on the App.
        </p>
        <p>
          7.6 If you download or stream the App onto any phone or other device
          not owned by you, you must have the owner's permission to do so. You
          will be responsible for complying with these terms, whether or not you
          own the phone or other device.
        </p>
        <p>
          7.7 By using the App, you agree to us collecting and using technical
          information about the devices you use the App on and related software,
          hardware and peripherals to improve our products and to provide any
          services to you. To the extent that we collect and use personal data,
          please see our privacy policy.
        </p>
      </Section>
      <Section>
        <Heading>8. Access Restrictions</Heading>
        <p>
          8.1 In consideration of your access to and use of The Sole Supplier
          Marketplace you agree that you will:
        </p>
        <UnorderedList>
          <li>
            comply with all applicable laws in relation to your use of The Sole
            Supplier Marketplace;
          </li>
          <li>
            not act in any way that is or is likely to be unlawful or
            fraudulent, or has or is likely to have any unlawful or fraudulent
            purpose or effect;
          </li>
          <li>
            not rent, lease, sub-license, loan, provide, or otherwise make
            available, The Sole Supplier Marketplace in any form, in whole or in
            part to any person without prior written consent from us;
          </li>
          <li>
            not copy The Sole Supplier Marketplace, except as part of the normal
            use of The Sole Supplier Marketplace or where it is necessary for
            the purpose of back-up or operational security or as otherwise set
            out in these terms;
          </li>
          <li>
            not translate, merge, adapt, vary, alter or modify, the whole or any
            part of The Sole Supplier Marketplace nor permit The Sole Supplier
            Marketplace or any part of them to be combined with, or become
            incorporated in, any other programs, except as necessary to use The
            Sole Supplier Marketplace on devices as permitted in these terms;
          </li>
          <li>
            not use any robot, spider, scraper or other automated means to
            access our The Sole Supplier Marketplace for any purpose;
          </li>
          <li>
            not take any action that imposes, or may impose an unreasonable or
            disproportionately large load on our infrastructure; and
          </li>
          <li>
            not disassemble, de-compile, reverse engineer or create derivative
            works based on the whole or any part of The Sole Supplier
            Marketplace nor attempt to do any such things, except to the extent
            that such actions cannot be prohibited under sections 50B and 296A
            of the Copyright, Designs and Patents Act 1988.
          </li>
        </UnorderedList>
        <p>
          8.2 You must keep your account details safe. If you choose to register
          on The Sole Supplier Marketplace, by providing us with a username,
          password, or any other piece of information as part of our security
          procedures, you must treat such information as confidential. You must
          not disclose it to any third party or allow a third party to access
          your account.
        </p>
        <p>
          8.3 We have the right to disable any account connected to any username
          or password, whether chosen by you or allocated by us, at any time, if
          in our reasonable opinion:
        </p>
        <UnorderedList>
          <li>
            we believe that there may be suspicious activity on your account
            and/or in respect of any of your past purchases; or
          </li>
          <li>
            you have failed to comply with any of the provisions of these terms
            of service.
          </li>
        </UnorderedList>
        <p>
          8.4 If you know or suspect that anyone other than you knows your
          username or password, you must promptly notify us at{' '}
          <Anchor href="mailto:compliance@solesupplier.co.uk">
            compliance@solesupplier.co.uk
          </Anchor>
          .
        </p>
      </Section>
      <Section>
        <Heading>
          9. How you may use material on our The Sole Supplier Marketplace
        </Heading>
        <p>
          9.1 We are the owner or the licensee of The Sole Supplier Marketplace
          and all textual, graphical and other content appearing on The Sole
          Supplier Marketplace. Those materials are protected by copyright laws
          and treaties around the world. All such rights are reserved. You have
          no intellectual property rights in, or to, The Sole Supplier
          Marketplace or the content on The Sole Supplier Marketplace other than
          the right to use them in accordance with these terms.
        </p>
        <p>
          9.2 You may view, copy, print and use content contained on The Sole
          Supplier Marketplace solely for your own personal use and provided
          that: (1) it is used for informational and non-commercial purposes
          only; (2) you must not modify the paper or digital copies of any
          materials you have printed off or downloaded in any way; and (3) you
          must not use or copy any photographs, video or audio sequences or
          graphics separate from any accompanying text.
        </p>
        <p>
          9.3 Our status and that of our identified contributors as the authors
          of content on The Sole Supplier Marketplace must always be
          acknowledged.
        </p>
        <p>
          9.4 If you print off, copy or download any part of The Sole Supplier
          Marketplace in breach of these terms of service, your right to use The
          Sole Supplier Marketplace will cease immediately and you must, at our
          option, return or destroy any copies of the materials you have made.
        </p>
      </Section>
      <Section>
        <Heading>10. Linking to Our Website</Heading>
        <p>
          10.1 You may link to our Website and/or App home page, provided you do
          so in a way that is fair and legal and does not damage our reputation
          or take advantage of it. You must not establish a link in such a way
          as to suggest any form of association, approval or endorsement on our
          part where none exists. You must not establish a link to our Website
          and/or App in any website that is not owned by you. Our Website and/or
          App must not be framed on any other site, nor may you create a link to
          any part of our site other than the home page. We reserve the right to
          withdraw linking permission without notice. The website in which you
          are linking must comply in all respects with the content standards set
          out below.
        </p>
      </Section>
      <Section>
        <Heading>11. User-Generated Content</Heading>
        <p>
          11.1 The Sole Supplier Marketplace may include information and
          materials uploaded by other users of The Sole Supplier Marketplace.
          This information and these materials have not been verified or
          approved by us. The views expressed by other users on our The Sole
          Supplier Marketplace do not represent our views or values.
        </p>
        <p>
          11.2 Whenever you make use of a feature that allows you to upload
          content to The Sole Supplier Marketplace, you must ensure that your
          content:
        </p>
        <UnorderedList>
          <li>
            is accurate where it states facts, and genuinely held where it
            states opinions;
          </li>
          <li>
            complies with the law applicable in England and Wales and in any
            country from which it is posted;
          </li>
          <li>
            is not defamatory, likely to deceive any person, obscene,
            threatening, abusive, offensive, hateful or inflammatory;
          </li>
          <li>
            does not promote sexually explicit material, violence,
            discrimination, illegal activity;
          </li>
          <li>
            does not infringe any intellectual property right of another person;
          </li>
          <li>
            does not breach any legal duty owned to a third party, such as a
            duty of confidence;
          </li>
          <li>
            does not impersonate any person, or misrepresent your identity or
            affiliation with any person;
          </li>
          <li>
            does not advocate, promote, incite any party to commit, or assist
            any unlawful or criminal act such as (by way of example only)
            copyright infringement or computer misuse; or
          </li>
          <li>
            does not contain any advertising or promote any services or web
            links to other sites.
          </li>
        </UnorderedList>
        <p>
          11.3 You warrant that any such contribution does comply with those
          standards, and you will be liable to us and indemnify us for any
          breach of that warranty. This means you will be responsible for any
          loss or damage we suffer as a result of your breach of warranty. We
          have the right to remove any posting you make on The Sole Supplier
          Marketplace if, in our opinion, your post does not comply with the
          content standards set out above.
        </p>
        <p>
          11.4 Should you use The Sole Supplier Marketplace to send any
          feedback, comments or enquiries, such as ideas, comments, suggestions
          or questions ("User Content"), such User Content shall be considered
          to be non-confidential and non-proprietary and you shall retain
          ownership rights in your content, but you hereby grant us a licence to
          reproduce, use, store, disclose and distribute and make available to
          third parties such User Content without limitation.
        </p>
        <p>
          11.5 We also have the right to disclose your identity to any third
          party who is claiming that any content posted or uploaded by you to
          The Sole Supplier Marketplace constitutes a violation of their
          intellectual property rights, or of their right to privacy.
        </p>
        <p>
          11.6 You are solely responsible for securing and backing up your
          content.
        </p>
      </Section>
      <Section>
        <Heading>
          12. Our responsibility for loss or damage suffered by you
        </Heading>
        <p>
          12.1 We do not exclude or limit in any way our liability to you where
          it would be unlawful to do so. This includes liability for death or
          personal injury caused by our negligence or the negligence of our
          employees, agents or subcontractors and for fraud or fraudulent
          misrepresentation.
        </p>
        <p>
          12.2 We only provide The Sole Supplier Marketplace for domestic and
          private use. You agree not to use The Sole Supplier Marketplace for
          any commercial or business purposes, and subject to paragraph 11.1,
          Sole shall not be liable under or in connection with these terms of
          service whether in contract or tort (including negligence) or
          otherwise for any (a) damage to software, (b) damage to or loss of
          data, profit, revenues, anticipated savings, goodwill or business
          opportunity; or (c) for any indirect or consequential loss or damage.
        </p>
        <p>
          12.3 If defective digital content that we have supplied, damages a
          device or digital content belonging to you and this is caused by our
          failure to use reasonable care and skill, we will either repair the
          damage or pay you compensation. However, we will not be liable for
          damage that you could have avoided by following our advice to apply an
          update offered to you free of charge or for damage that was caused by
          you failing to correctly follow installation instructions or to have
          in place the minimum system requirements advised by us.
        </p>
        <p>
          12.4 If we fail to comply with these terms, we are responsible for
          loss or damage you suffer that is a foreseeable result of our breaking
          these terms or our failing to use reasonable care and skill, but we
          are not responsible for any loss or damage that is not foreseeable.
          Loss or damage is foreseeable if either it is obvious that it will
          happen or if, at the time you accepted these terms, both we and you
          knew it might happen
        </p>
        <p>
          12.5 If you have a dispute with a seller, you release Sole from
          claims, demands and damages (actual and consequential) of every kind
          and nature, known and unknown, arising out of or in any way connected
          with any such dispute.
        </p>
      </Section>
      <Section>
        <Heading>13. Territory</Heading>
        <p>
          13.1 We are based in the United Kingdom and any and all information on
          The Sole Supplier Marketplace is provided to you in accordance with
          the laws and regulations of England and Wales, irrespective of where
          you access The Sole Supplier Marketplace from.
        </p>
        <p>
          13.2 Please note that when you click through to a Third Party, you
          will need to review the terms and conditions of that site and make
          yourself aware of the jurisdiction within which it is based, your
          purchase (should you make one) will be subject to the terms of that
          site and the local laws. Furthermore please note that some products
          may not be available in your country due to availability constraints.
        </p>
      </Section>
      <Section>
        <Heading>14. Security</Heading>
        <p>
          14.1 We do not guarantee that our The Sole Supplier Marketplace will
          be secure or free from bugs or viruses.
        </p>
        <p>
          14.2 You are responsible for configuring your device, information
          technology, computer programmes and platform to access our The Sole
          Supplier Marketplace. You should use your own virus protection
          software.
        </p>
        <p>
          14.3 You must not misuse The Sole Supplier Marketplace by knowingly
          introducing viruses, trojans, worms, logic bombs or other material
          that is malicious or technologically harmful. You must not attempt to
          gain unauthorised access to The Sole Supplier Marketplace, the server
          on which The Sole Supplier Marketplace are stored or any server,
          computer or database connected to The Sole Supplier Marketplace. You
          must not attack The Sole Supplier Marketplace via a denial-of-service
          attack or a distributed denial-of service attack. By breaching this
          provision, you would commit a criminal offence under the Computer
          Misuse Act 1990. We will report any such breach to the relevant law
          enforcement authorities and we will co-operate with those authorities
          by disclosing your identity to them. In the event of such a breach,
          your right to use The Sole Supplier Marketplace will cease
          immediately.
        </p>
        <p>
          14.4 Please be aware that internet transmissions are never completely
          private or secure and that any message or information you send using
          The Sole Supplier Marketplace may be read or intercepted by others,
          even if there is a special notice that a particular transmission is
          encrypted.
        </p>
      </Section>
      <Section>
        <Heading>15. Termination</Heading>
        <p>15.1 If we end your rights to use The Sole Supplier Marketplace:</p>
        <UnorderedList>
          <li>
            you must stop all activities authorised by these terms, including
            your use of The Sole Supplier Marketplace;
          </li>
          <li>
            you must delete or remove the App from all devices in your
            possession and immediately destroy all copies of the App which you
            have and confirm to us that you have done this; and
          </li>
          <li>
            we may remotely access your devices and remove the App from them and
            cease providing you with access to the services available via the
            App.
          </li>
        </UnorderedList>
        <p>15.2 If you are a consumer:</p>
        <UnorderedList>
          <li>
            you agree that we will commence supplying the services to you as
            soon as you accept these terms of service; and
          </li>
          <li>
            you can terminate your account for any reason under the Consumer
            Contracts (Information, Cancellation and Additional Charges)
            Regulations 2013 within 14 days of registering with us.
          </li>
        </UnorderedList>
        <p>
          15.3 Otherwise, you may delete your account at any time by logging
          onto your account and selecting ‘delete my account’ under ‘My
          Account’.
        </p>
      </Section>
      <Section>
        <Heading>
          16. Right of Cancellation for products bought on The Sole Supplier
          Marketplace
        </Heading>
        <p>
          16.1 Where you purchase a product on The Sole Supplier Marketplace
          from a business seller (indicated during the purchase process), rather
          than an individual seller and you are a consumer, you have a legal
          right to change your mind within 14 days of receipt and receive a
          refund, provided that you have not used the product in any way. If you
          received your item and it has arrived not as described, please contact
          Customer Service within 3 working days and include your order number
          and a photo(s) of the issue you're referring to so that we can review
          it. Where you wish to exercise this right, you must email us at{' '}
          <Anchor href="mailto:support@thesolesupplier.zendesk.com">
            support@thesolesupplier.zendesk.com
          </Anchor>
          .
        </p>
        <p>
          16.2 If you end the contract for any reason after products have been
          dispatched to you or you have received them, you must promptly return
          them to The Sole Supplier at the address notified to you. You will be
          responsible for the postage cost of returning the product.
        </p>
      </Section>
      <Section>
        <Heading>17. Third Party Rights</Heading>
        <p>
          17.1 A person who is not a party to these terms of service has no
          right under the Contracts (Rights of Third Parties) Act 1999 to
          enforce any term of these terms.
        </p>
        <p>
          17.2 You may not resell, assign, sub-licence or otherwise transfer any
          of the rights under these terms without Sole’s prior written consent.
        </p>
      </Section>
      <Section>
        <Heading>18. Waiver</Heading>
        <p>
          18.1 If Sole fails, at any time to insist upon strict performance of
          any of your obligations under these terms of service, or if Sole fails
          to exercise any of the rights or remedies to which Sole is entitled
          under these terms, this shall not constitute a waiver of such rights
          or remedies and shall not relieve you from compliance with such
          obligations.
        </p>
        <p>
          18.2 A waiver by Sole of any default shall not constitute a waiver of
          any subsequent default.
        </p>
      </Section>
      <Section>
        <Heading>19. Severance</Heading>
        <p>
          19.1 If any provision (or part of a provision) of these terms of
          service is found by any court or administrative body of competent
          jurisdiction to be invalid, unenforceable or illegal, such term,
          condition or provision will to that extent be severed from the
          remaining terms, conditions and provisions which will continue to be
          valid to the fullest extent permitted by law.
        </p>
      </Section>
      <Section>
        <Heading>20. Applicable Law and Jurisdiction</Heading>
        <p>
          20.1 These terms of service, their subject matter and formation (and
          any non-contractual disputes or claims) are governed by English law
          and The Sole Supplier Marketplace is intended to be used by consumers
          from the UK. You and we both agree that the courts of England and
          Wales will have exclusive jurisdiction, except that if you are a
          resident of Northern Ireland you may also bring proceedings in
          Northern Ireland, and if you are resident of Scotland, you may also
          bring proceedings in Scotland.
        </p>
      </Section>
      <Section>
        <Heading>21. The Sole Supplier Golden Ticket</Heading>
        <p>
          21.1 Overview The Golden Ticket Loyalty Programme ("Programme") is
          designed to reward our loyal customers who make purchases through our
          app. By participating in this Programme, you agree to these terms and
          conditions.
        </p>
        <p>
          21.2 Eligibility The Programme is open to all users who make a
          purchase via our app. There is no additional cost to participate in
          the Programme. Employees of The Sole Supplier are not eligible for the
          Programme.
        </p>
        <p>
          21.3 How It Works Participation: All users who make a purchase via our
          app are automatically entered into the Programme. Selection: At random
          intervals, a select number of users who have made a purchase during a
          specific period will be eligible to receive a golden ticket.
          Notification: Users who receive a golden ticket will be notified via
          email or in-app notification.
        </p>
        <p>
          21.4 Rewards Golden Ticket: Each golden ticket entitles the recipient
          to be in with a chance to get a prize between the value of £50-£500.
          Non-Transferable: Golden tickets and their associated rewards are
          non-transferable and cannot be exchanged for cash or any other form of
          compensation.
        </p>
        <p>
          21.5 Users must have an active account and be in good standing to
          receive a golden ticket. The Sole Supplier reserves the right to
          modify, suspend, or terminate the Programme at any time without prior
          notice. Any attempt to manipulate the Programme or violate these terms
          and conditions may result in disqualification from the Programme and
          forfeiture of any rewards.
        </p>
        <p>
          21.6 Legal Compliance The Programme is subject to all applicable laws
          and regulations. By participating, you agree to release The Sole
          Supplier from any liability arising from your participation in the
          Programme or the receipt of any rewards.
        </p>
        <p>
          21.7 Personal data collected in connection with the Programme will be
          used in accordance with our Privacy Policy. The Sole Supplier will not
          share your personal information with third parties without your
          consent, except as required by law.
        </p>
        <p>
          21.8 The Sole Supplier reserves the right to amend these terms and
          conditions at any time.
        </p>
      </Section>
      <Section>
        <Heading>22. Complaints and Alternative Dispute Resolution</Heading>
        <p>
          22.1 Please notify us immediately of any concerns in respect of an
          item purchased from a seller at{' '}
          <Anchor href="mailto:support@thesolesupplier.zendesk.com">
            support@thesolesupplier.zendesk.com
          </Anchor>
          and we will raise a ticket and investigate your complaint.
        </p>
        <p>
          22.2 If you are unhappy with The Sole Supplier Marketplace or any of
          our services, please contact us at{' '}
          <Anchor href="mailto:support@thesolesupplier.zendesk.com">
            support@thesolesupplier.zendesk.com
          </Anchor>
          and we will seek to resolve your complaint internally. If you are
          unhappy with a particular product that you have purchased, please
          contact us and we will liaise with the seller on your behalf.
        </p>
        <p>
          22.3 If we are unable to resolve your complaint through our internal
          procedures, we will consider reasonable requests to resolve the
          dispute through alternative dispute resolution procedures, such as
          mediation or arbitration, as alternatives to litigation.
        </p>
        <p>
          22.4 Alternative dispute resolution is a process where an independent
          body considers the facts of a dispute and seeks to resolve it, without
          you having to go to court. If you are not happy with how we have
          handled any complaint, you may want to contact your local Trading
          Standards Services which can found at{' '}
          <Anchor href="https://www.tradingstandards.uk/consumers/support-advice.">
            https://www.tradingstandards.uk/consumers/support-advice.
          </Anchor>
        </p>
      </Section>
    </>
  );
}
